// Direct process.env.REACT_APP_* access is required. Create React App
// inlines those exact references at build time and ignores dynamic lookups.

export const APP_MODE = process.env.REACT_APP_MODE || "dev";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://erpserver.hitech-prime.com/api/v1/";

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "";

export const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || "";

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
